// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fourBody[data-v-cca4b9aa] {\n  padding: 10px 20px;\n}", ""]);
// Exports
module.exports = exports;
